<template>
  <Teleport to="body">
    <div
      v-if="open"
      class="mobile-search-overlay"
      data-testid="mobile-search-overlay"
    >
      <div class="mobile-search-overlay__panel">
        <div class="mobile-search-overlay__header">
          <button
            class="mobile-search-overlay__close"
            data-testid="mobile-search-overlay-close"
            type="button"
            aria-label="Close menu"
            @click="closeOverlay"
          >
            <span class="mobile-search-overlay__close-icon ion-close" aria-hidden="true"></span>
          </button>
        </div>
        <div class="mobile-search-overlay__content">
          <TopSearchBar :autofocus="true" source="mobile_quick_search" />
          <nav class="mobile-search-overlay__nav" aria-label="Mobile navigation">
            <a class="mobile-search-overlay__link" href="/discover">Discover</a>
            <template v-if="isAuthenticated">
              <a class="mobile-search-overlay__link" href="/home">
                Home: {{ authUsername }}
              </a>
              <a class="mobile-search-overlay__link" href="/logout">Sign out</a>
            </template>
            <template v-else>
              <a class="mobile-search-overlay__link" href="/login">Log in</a>
              <a class="mobile-search-overlay__link" href="/sign-up">Register</a>
            </template>
          </nav>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { computed, onBeforeUnmount, watch } from 'vue'
import TopSearchBar from './TopSearchBar.vue'
import { useAuthStore } from '../stores/auth'

const props = defineProps({
  open: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['close'])
const auth = useAuthStore()

const isAuthenticated = computed(() => auth.isAuthenticated.value)
const authUsername = computed(() => auth.state.username || 'Account')

function closeOverlay() {
  emit('close')
}

function handleKeydown(event) {
  if (event.key === 'Escape' && props.open) {
    closeOverlay()
  }
}

watch(
  () => props.open,
  (isOpen) => {
    if (typeof document === 'undefined') {
      return
    }
    document.body.style.overflow = isOpen ? 'hidden' : ''
    document.documentElement.classList.toggle('mobile-search-overlay-open', isOpen)
    document.body.classList.toggle('mobile-search-overlay-open', isOpen)
    if (isOpen) {
      document.addEventListener('keydown', handleKeydown)
      return
    }
    document.removeEventListener('keydown', handleKeydown)
  },
  { immediate: true },
)

onBeforeUnmount(() => {
  if (typeof document === 'undefined') {
    return
  }
  document.body.style.overflow = ''
  document.documentElement.classList.remove('mobile-search-overlay-open')
  document.body.classList.remove('mobile-search-overlay-open')
  document.removeEventListener('keydown', handleKeydown)
})
</script>
